
export default class Log {
    static error(msg: string, e: string | object, ...args: any[]) {
      if (!e) e = '';
      if (!args.length) args = [];
      if (typeof msg == 'object') msg = JSON.stringify(msg);
      console.error(`[ERR]: ${msg.toString()}`, e, args);
    }
    static warn(msg: string, e: string | object, ...args: any[]) {
      if (!e) e = '';
      if (!args.length) args = [];
      if (typeof msg == 'object') msg = JSON.stringify(msg);
      console.warn(`[WARN]: ${msg.toString()}`, e, args);
    }
    static trace(msg: string, e: string | object, ...args: any[]) {
      if (!e) e = '';
      if (!args.length) args = [];
      if (typeof msg == 'object') msg = JSON.stringify(msg);
      console.log(`[TRACE]: ${msg.toString()}`, e, args);
    }
    static info(msg: string, e: string | object, ...args: any[]) {
      if (!e) e = '';
      if (!args.length) args = [];
      if (typeof msg == 'object') msg = JSON.stringify(msg);
      console.log(`[INFO]: ${msg.toString()}`, e, args);
    }
}
  
export { Log };